import React from 'react';

export const ComponentsContext = React.createContext({});
